module.exports = __webpack_public_path__ + "assets_1789457014240/img/logo_v1.098beea9.png";